module.exports = __webpack_public_path__ + "img/long-arrow-01.76305a0a.svg";